import { Card, convertISOStringToLocalDateString, ImageNotFound } from '@gcl/react-core';
import { ISignature } from '@userProfile/userProfile.models';
import * as React from 'react';
import './SignatureCard.scss';

interface ISignatureCardProps {
  title?: string | React.ReactElement;
  signProfile?: ISignature;
  signImage?: string;
  signUser?: string;
  signDate?: string;
  className?: string;
  onRenderContent?: (signatureComponent?: React.ReactElement) => React.ReactElement;
}

export const SignatureCard: React.FunctionComponent<ISignatureCardProps> = ({
  title,
  signProfile,
  signImage,
  signUser,
  signDate,
  className = '',
  onRenderContent,
}) => {
  const signatureComponent: React.ReactElement | undefined = React.useMemo(() => {
    if (!signUser) return undefined;

    const getSignatureBase64 = (signature?: ISignature) => {
      return signature ? `data:${signature?.mime};base64,${signature.fileContent}` : undefined;
    };
    const signImageLocal = signImage ?? getSignatureBase64(signProfile);

    return (
      <div className="gcl-gems-signature-card-content">
        <div className="gcl-gems-signature-card-content-img-container">
          {signImageLocal ? (
            <img src={signImageLocal || ''} alt="Signature" className="gcl-gems-signature-card-content-img" />
          ) : (
            <ImageNotFound shouldUseFullHeight />
          )}
        </div>
        <div className="gcl-gems-signature-card-content-user">
          <span>{signUser}</span>
          {signDate && <span>{convertISOStringToLocalDateString(signDate)}</span>}
        </div>
      </div>
    );
  }, [signImage, signDate, signUser]);

  return (
    <Card
      className={`gcl-gems-signature-card ${className}`}
      title={title}
      content={onRenderContent ? onRenderContent(signatureComponent) : signatureComponent}
    />
  );
};
